<template>
  <div class="indicator">
    <div class="indicator__wrapper">
      <div
        class="indicator__value indicator--rounded-left tooltip"
        :class="{
          'indicator--rounded-right': valueWidth === 100,
          'zero-data': valueWidth === null,
        }"
        :style="`flex: ${tooSmallSizeForEyes(valueWidth) ? valueWidth : 5}%`"
      >
        <span class="tooltiptext"
          >{{ tooltipHighQuality }}: {{ highQuality }}</span
        >
      </div>
      <!-- Скругление графиков до минимального видимого округления при маленьком значении 1-5  -->
      <div
        class="indicator__capacity indicator--rounded-right tooltip"
        :class="{
          'indicator--rounded-left': valueWidth === 0,
          'zero-data': valueWidth === null,
        }"
        :style="`flex: ${
          tooSmallSizeForEyes(valueWidth) ? 100 - valueWidth : 95 - valueWidth
        }%`"
      >
        <span class="tooltiptext"
          >{{ tooltipLowQuality }}: {{ lowQuality }}</span
        >
      </div>
    </div>
    <span class="indicator__text">{{ value !== null ? value : "" }}%</span>
  </div>
</template>

<script>
import { computed, ref } from "vue";

export default {
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      required: true,
    },
    highQuality: {
      type: Number,
      default: -1,
    },
    lowQuality: {
      type: Number,
      default: -1,
    },
    tooltipHighQuality: {
      type: String,
      default: "Количество качественных документов",
    },
    tooltipLowQuality: {
      type: String,
      default: "Количество некачественных документов",
    },
  },

  setup(props) {
    const indicatorWrapper = ref(null);
    const valueWidth = computed(() =>
      props.value === null
        ? null
        : Math.floor((props.value * 100) / (props.max - props.min))
    );

    function tooSmallSizeForEyes(width) {
      if (width == 0 || width > 5) return true;

      return false;
    }

    return {
      indicatorWrapper,
      valueWidth,
      tooSmallSizeForEyes,
    };
  },
};
</script>

<style scoped>
.indicator {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}
.indicator__wrapper {
  display: flex;
  position: relative;
  width: 100%;
  height: 8px;
}
.indicator__value {
  background-color: var(--primary-blue-lighter);
  height: 100%;
}
.indicator__capacity {
  background-color: var(--basic-pink);
  height: 100%;
}
.zero-data {
  background-color: var(--basic-grey-dark);
  height: 100%;
}
.indicator--rounded-left {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.indicator--rounded-right {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.indicator__text {
  width: 65px;
}

.indicator__value .tooltiptext {
  font-size: 14px;
  line-height: 18px;
  font-weight: 100;
}
</style>
